import 'assets/css/modal.css';
import 'styles/custom.css';
import * as React from 'react';
import { getRegionNames, updateDefaultSetting, updateScheduledTriggerItemLimitForSite, searchScheduledTriggerItemLimitBySpHostUrl, updateScheduledTriggerDailyFrequencyForSite, searchScheduledTriggerDailyFrequencyBySpHostUrl, GetCurrentDefaultSetting } from "../components/Requests/Requests"
import { 
  StandardScreen,
  StandardSearchBox, 
  StandardDropdown, 
  StandardTextField,
  StandardButton, 
  StatusMessage,
  PageLayout,
} from '../components/Layout';
import Theme from 'styles/theme';


class ScheduledTriggerUtilities extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            itemLimit: "",
            itemLimitSpHostUrl: "",
            itemLimitSpHostUrlExists: false,
            itemLimitRegionNameChosen: "",
            itemLimitMessage: "",
            itemLimitError: "",
            frequencyChosen: "",
            frequencySpHostUrl: "",
            frequencySpHostUrlExists: false,
            frequencyRegionNameChosen: "",
            frequencyMessage: "",
            frequencyError: "",
            defaultItemLimit: "",
            defaultItemLimitMessage: "",
            defaultItemLimitError: "",
            regionNames: "",
            loading: false,
            loadingItemLimit: false,
            loadingFrequency: false,
            loadingDefaultLimit: false,

            globalItemLimit: null,
            itemLimitHasOwnLimit: false,
            itemLimitCurrent: null,
        }
    }

    componentDidMount() {
        this.initializeSettings();
    }

    initializeSettings() {
        this.getRegionNames();
        this.getGlobalItemLimit();
    }

    async getRegionNames() {
        this.setState({ loading: true })
        let response = await getRegionNames(this.props.accessToken);
        if (response.status === 200) {
            let data = await response.json();
            this.setState({
                loading: false,
                regionNames: data.map(item =>
                    ({ key: item, text: item })),
            });
        } else {
            this.setState({ loading: false, error: "Something went wrong", message: "" });
        };
    }

    async getGlobalItemLimit() {
      let response = await GetCurrentDefaultSetting(this.props.accessToken, "ScheduledTriggerItemLimit");
      if (response.status === 200) {
        const data = await response.json();
        this.setState({ globalItemLimit: data.value});
      }
    }

    async updateDefaultItemLimit(requestBody) {
        this.setState({ loadingDefaultLimit: true })
        let response = await updateDefaultSetting(this.props.accessToken, requestBody);
        if (response.status === 200) {
            let data = await response.json();
            this.setState({ defaultItemLimitError: "", defaultItemLimitMessage: data.message, loadingDefaultLimit: false });
        } else if(response.status === 401){
            this.setState({ loadingDefaultLimit: false, defaultItemLimitError: "You are not permitted to use this feature. You must request admin permissions", message: "" });
        }
        else {
            this.setState({ loadingDefaultLimit: false, defaultItemLimitError: "Something went wrong", defaultItemLimitMessage: "" });
        };
    }

    async updateScheduledTriggerItemLimitForSite(requestBody) {
        this.setState({ loadingItemLimit: true })
        let response = await updateScheduledTriggerItemLimitForSite(this.props.accessToken, requestBody);
        if (response.status === 200) {
            let data = await response.json();
            // Reflect the change in the current-limit display without a second lookup.
            // A null limit means it was reset to the global default.
            this.setState({
                itemLimitError: "",
                itemLimitMessage: data.message,
                loadingItemLimit: false,
                itemLimit: "",
                itemLimitHasOwnLimit: requestBody.scheduledTriggerItemLimit != null,
                itemLimitCurrent: requestBody.scheduledTriggerItemLimit
            });
        } else {
            this.setState({ loadingItemLimit: false, itemLimitError: "Something went wrong", itemLimitMessage: "", itemLimitSpHostUrlExists: false });
        };
    }

    async searchScheduledTriggerItemLimitBySpHostUrl(requestBody) {
        this.setState({ loadingItemLimit: true })
        let response = await searchScheduledTriggerItemLimitBySpHostUrl(this.props.accessToken, requestBody);
        // Ignore a stale response: the host box may have been cleared/changed (e.g. the X button)
        // while this lookup was in flight, which would otherwise repopulate cleared results.
        if (requestBody.spHostUrl !== this.state.itemLimitSpHostUrl) {
            this.setState({ loadingItemLimit: false });
            return;
        }
        let data = await response.json();
        if (response.status === 200) {
            this.setState({
                itemLimitError: "",
                itemLimitMessage: "",
                loadingItemLimit: false,
                itemLimitSpHostUrlExists: true,
                itemLimitHasOwnLimit: data.hasItemLimit,
                itemLimitCurrent: data.itemLimit
            });
        } else {
            this.setState({
                itemLimitError: data.message || "Something went wrong",
                itemLimitMessage: "",
                loadingItemLimit: false,
                itemLimitSpHostUrlExists: false,
                itemLimitHasOwnLimit: false,
                itemLimitCurrent: null
            });
        };
    }

    async updateScheduledTriggerDailyFrequencyForSite(requestBody) {
        this.setState({ loadingFrequency: true })
        let response = await updateScheduledTriggerDailyFrequencyForSite(this.props.accessToken, requestBody);
        if (response.status === 200) {
            let data = await response.json();
            this.setState({ frequencyError: "", frequencyMessage: data.message, loadingFrequency: false, frequencySpHostUrlExists: false });
        } else {
            this.setState({ loadingFrequency: false, frequencyError: "Something went wrong", frequencyMessage: "", frequencySpHostUrlExists: false });
        };
    }

    async searchScheduledTriggerDailyFrequencyBySpHostUrl(requestBody) {
        this.setState({ loadingFrequency: true })
        let response = await searchScheduledTriggerDailyFrequencyBySpHostUrl(this.props.accessToken, requestBody);
        let data = await response.json();
        if (response.status === 200) {
            this.setState({ frequencyError: "", frequencyMessage: data.message, loadingFrequency: false, frequencySpHostUrlExists: true });
        } else {
            this.setState({ frequencyError: data.message, frequencyMessage: "", loadingFrequency: false, frequencySpHostUrlExists: false });
        };
    }

    onSelectItemLimitRegionName = (event, item) => {
        // Changing the environment invalidates any previous lookup, so hide the
        // results until the user runs Search again.
        this.setState({
            itemLimitRegionNameChosen: item.key,
            itemLimitSpHostUrlExists: false,
            itemLimitError: "",
            itemLimitMessage: ""
        });
    };

    onSelectFrequencyRegionName = (event, item) => {
        this.setState({ frequencyRegionNameChosen: item.key });
    };

    onSelectFrequency = (event, item) => {
        this.setState({ frequencyChosen: item.key });
    };

    constructAndSendRequest(actionType) {

        let requestBody = {};

        switch (actionType) {
            case "submitItemLimit":
                requestBody = {
                    spHostUrl: this.state.itemLimitSpHostUrl,
                    regionName: this.state.itemLimitRegionNameChosen,
                    scheduledTriggerItemLimit: this.state.itemLimit === "" ? null : this.state.itemLimit
                };
                this.updateScheduledTriggerItemLimitForSite(requestBody);
                break;
            case "resetItemLimit":
                requestBody = {
                    spHostUrl: this.state.itemLimitSpHostUrl,
                    regionName: this.state.itemLimitRegionNameChosen,
                    scheduledTriggerItemLimit: null
                };
                this.updateScheduledTriggerItemLimitForSite(requestBody);
                break;
            case "submitDefaultItemLimit":
                requestBody = {
                    settingValue: this.state.defaultItemLimit === "" ? null : this.state.defaultItemLimit,
                    settingName: "ScheduledTriggerItemLimit",
                };
                this.updateDefaultItemLimit(requestBody);
                break;
            case "submitDailyFrequency":
                requestBody = {
                    spHostUrl: this.state.frequencySpHostUrl,
                    regionName: this.state.frequencyRegionNameChosen,
                    scheduledTriggerDailyFrequency: this.state.frequencyChosen === "" ? null : this.state.frequencyChosen
                };
                this.updateScheduledTriggerDailyFrequencyForSite(requestBody);
                break;
            case "searchItemLimitBySpHost":
                requestBody = {
                    spHostUrl: this.state.itemLimitSpHostUrl,
                    regionName: this.state.itemLimitRegionNameChosen,
                };
                this.searchScheduledTriggerItemLimitBySpHostUrl(requestBody);
                break;
            case "searchDailyFrequencyBySpHost":
                requestBody = {
                    spHostUrl: this.state.frequencySpHostUrl,
                    regionName: this.state.frequencyRegionNameChosen,
                };
                this.searchScheduledTriggerDailyFrequencyBySpHostUrl(requestBody);
                break;
            default:
                console.log("Invalid submit type");
                break;
        }
    }

    render() {
        const frequencyOptions = [
            { key: '1', text: 'Once per day' },
            { key: '2', text: 'Twice per day' },
            { key: '3', text: 'Three times per day' }
        ];

        const itemLimitInputsSelected = !!this.state.itemLimitSpHostUrl && !!this.state.itemLimitRegionNameChosen;

        return (
            <PageLayout>
                <StandardScreen
                    title="Item Limit for Specific SPHostURL"
                    description="Change the item limit for scheduled triggers for a specific SPHostURL. Use 'Reset to default' to revert a site back to the global default"
                    loading={this.state.loading}
                >
                    <StandardDropdown
                        label="Environment"
                        selectedKey={this.state.itemLimitRegionNameChosen}
                        onChange={this.onSelectItemLimitRegionName}
                        placeholder="Select Environment"
                        options={this.state.regionNames}
                        disabled={!this.state.regionNames || this.state.regionNames.length === 0}
                    />

                    <StandardSearchBox
                        label="SPHostUrl"
                        placeholder="SPHostUrl"
                        value={this.state.itemLimitSpHostUrl}
                        disabled={!this.state.itemLimitRegionNameChosen}
                        onChange={newValue => this.setState({
                            itemLimitSpHostUrl: newValue,
                            itemLimitError: "",
                            itemLimitMessage: "",
                            itemLimitSpHostUrlExists: false
                        })}
                        onClear={() => this.setState({
                            itemLimitSpHostUrl: "",
                            itemLimitError: "",
                            itemLimitMessage: "",
                            itemLimitSpHostUrlExists: false,
                            itemLimitHasOwnLimit: false,
                            itemLimitCurrent: null
                        })}
                    />

                    <StandardButton
                        text={this.state.loadingItemLimit ? "Searching..." : "Search"}
                        onClick={() => this.constructAndSendRequest("searchItemLimitBySpHost")}
                        disabled={!this.state.itemLimitSpHostUrl || !this.state.itemLimitRegionNameChosen || this.state.loadingItemLimit}
                    />

                    {this.state.itemLimitSpHostUrlExists && (
                        <div style={{
                            fontSize: Theme.typography.fontSize.medium,
                            color: Theme.colors.text,
                            marginBottom: Theme.spacing.lg
                        }}>
                            {this.state.itemLimitHasOwnLimit
                                ? <span>Current item limit: <span style={{ color: Theme.colors.success, fontFamily: 'Consolas, "Courier New", monospace' }}>{this.state.itemLimitCurrent}</span></span>
                                : <span>Currently using global default: <span style={{ color: Theme.colors.success, fontFamily: 'Consolas, "Courier New", monospace' }}>{this.state.globalItemLimit}</span></span>}
                        </div>
                    )}

                    {this.state.itemLimitSpHostUrlExists && (
                        <StandardTextField
                            label="Limit"
                            type="number"
                            min={0}
                            placeholder="New Item Limit"
                            value={this.state.itemLimit}
                            onChange={(event, newValue) => {
                                // Ignore negative values so the limit can't go below zero
                                if (newValue !== "" && (newValue.includes("-") || Number(newValue) < 0)) {
                                    return;
                                }
                                this.setState({
                                    itemLimit: newValue,
                                    itemLimitError: "",
                                    itemLimitMessage: ""
                                });
                            }}
                        />
                    )}

                    {this.state.itemLimitSpHostUrlExists && (
                        <div style={{ display: 'flex', gap: '20px' }}>
                            <StandardButton
                                text={this.state.loadingItemLimit ? "Submitting..." : "Submit"}
                                onClick={() => this.constructAndSendRequest("submitItemLimit")}
                                disabled={!this.state.itemLimit || this.state.loadingItemLimit}
                            />
                            <StandardButton
                                text="Reset to default"
                                onClick={() => this.constructAndSendRequest("resetItemLimit")}
                                disabled={!this.state.itemLimitHasOwnLimit || this.state.loadingItemLimit}
                            />
                        </div>
                    )}

                    {itemLimitInputsSelected && this.state.itemLimitError && (
                        <StatusMessage type="error">{this.state.itemLimitError}</StatusMessage>
                    )}

                    {this.state.itemLimitMessage && (
                        <StatusMessage type="success">{this.state.itemLimitMessage}</StatusMessage>
                    )}
                </StandardScreen>

                <StandardScreen
                    title="Global Default Item Limit"
                    description="Change the default item limit for all scheduled triggers, for all SPHostURLs and in all environments"
                    loading={this.state.loading}
                >
                    {this.state.globalItemLimit != null && (
                        <div style={{
                            fontSize: Theme.typography.fontSize.medium,
                            color: Theme.colors.text,
                            marginBottom: Theme.spacing.lg
                        }}>
                            Current default: <span style={{ color: Theme.colors.success, fontFamily: 'Consolas, "Courier New", monospace' }}>{this.state.globalItemLimit}</span>
                        </div>
                    )}

                    <StandardTextField
                        label="Limit"
                        type="number"
                        min={0}
                        placeholder="New Default Item Limit"
                        value={this.state.defaultItemLimit}
                        onChange={(event, newValue) => {
                            // Ignore negative values so the default limit can't go below zero
                            if (newValue !== "" && (newValue.includes("-") || Number(newValue) < 0)) {
                                return;
                            }
                            this.setState({
                                defaultItemLimit: newValue,
                                defaultItemLimitError: "",
                                defaultItemLimitMessage: ""
                            });
                        }}
                    />

                    <StandardButton
                        text={this.state.loadingDefaultLimit ? "Submitting..." : "Submit"}
                        onClick={() => this.constructAndSendRequest("submitDefaultItemLimit")}
                        disabled={!this.state.defaultItemLimit || this.state.loadingDefaultLimit}
                    />

                    {this.state.defaultItemLimitError && (
                        <StatusMessage type="error">{this.state.defaultItemLimitError}</StatusMessage>
                    )}

                    {this.state.defaultItemLimitMessage && (
                        <StatusMessage type="success">{this.state.defaultItemLimitMessage}</StatusMessage>
                    )}
                </StandardScreen>

                <StandardScreen
                    title="Daily Evaluation Frequency for Specific SPHostUrl"
                    description="Change the frequency at which scheduled triggers are evaluated each day for a specific SPHostURL"
                    loading={this.state.loading}
                >
                    <StandardSearchBox
                        label="SPHostUrl"
                        placeholder="SPHostUrl"
                        value={this.state.frequencySpHostUrl}
                        onChange={newValue => this.setState({ 
                            frequencySpHostUrl: newValue,
                            frequencyError: "",
                            frequencyMessage: ""
                        })}
                    />

                    <StandardDropdown
                        label="Environment"
                        selectedKey={this.state.frequencyRegionNameChosen}
                        onChange={this.onSelectFrequencyRegionName}
                        placeholder="Select Environment"
                        options={this.state.regionNames}
                        disabled={!this.state.regionNames || this.state.regionNames.length === 0}
                    />

                    <StandardDropdown
                        label="Frequency"
                        selectedKey={this.state.frequencyChosen}
                        onChange={this.onSelectFrequency}
                        placeholder="New Daily Frequency"
                        options={frequencyOptions}
                        disabled={!this.state.frequencySpHostUrlExists}
                    />

                    <div style={{ display: 'flex', gap: '20px' }}>
                        <StandardButton
                            text={this.state.loadingFrequency ? "Searching..." : "Search"}
                            onClick={() => this.constructAndSendRequest("searchDailyFrequencyBySpHost")}
                            disabled={!this.state.frequencySpHostUrl || !this.state.frequencyRegionNameChosen || this.state.loadingFrequency}
                            style={{ marginRight: '10px' }}
                        />
                        <StandardButton
                            text={this.state.loadingFrequency ? "Submitting..." : "Submit"}
                            onClick={() => this.constructAndSendRequest("submitDailyFrequency")}
                            disabled={!this.state.frequencySpHostUrlExists || this.state.loadingFrequency}
                        />
                    </div>

                    {this.state.frequencyError && (
                        <StatusMessage type="error">{this.state.frequencyError}</StatusMessage>
                    )}

                    {this.state.frequencyMessage && (
                        <StatusMessage type="success">{this.state.frequencyMessage}</StatusMessage>
                    )}
                </StandardScreen>
            </PageLayout>
        );
    }
}

export default ScheduledTriggerUtilities;
